import { buildConfigVariables } from "@/config/general/utils";
import { color } from "framer-motion";
import Link from "next/link";
import { env } from "process";
import React, { useEffect, useState } from "react";

const CopyrightArea = ({ wrapperClass, footerClass }: any) => {
  const [environment, setEnvironment] = useState<string>("");
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    const loadConfig = async () => {
      const config = await buildConfigVariables();
      setEnvironment(config.ENVIRONMENT || "");
    };
    loadConfig();
  }, []);

  return (
    <div
      className={
        footerClass ? `footer__bottom ${footerClass}` : "footer__bottom"
      }
    >
      <div className="container">
        <div className="row">
          <div className="col-xxl-12">
            <div
              className={
                wrapperClass
                  ? `footer__copyright text-center ${wrapperClass}`
                  : "footer__copyright text-center"
              }
            >
              <p>
                © {currentYear} Operated by MEMOCIPE LTD · 
                      Registered in England and Wales · Company No. 16421518 · All Rights Reserved.
              </p>
              <span>{
                environment !== "Production" ? "": `Environment: ${environment}`
              }</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CopyrightArea;
